import { ReactNode } from 'react';
import ReactModal from 'react-modal';

import { Props } from 'lib/modal/simple-modal';
import { ModalBaseCss } from 'lib/modal/modal.constants';
import {
  ActivitySheetCloseButton,
  ActivitySheetContent,
  ActivitySheetScrollable,
} from './activity-sheet.style';
import { grey1, grey2 } from 'approot/shared/styles/colours.style';
import { ACTIVITY_SHEET_CONTAINER } from './activity-sheet.utils';
import { SecondaryButtonIcon } from 'approot/shared/styles/buttons/secondary-button.style';
import IconClose from 'approot/shared/icons/icon-close';

const ActivitySheet = ({
  children,
  size,
  title,
  tabsContent,
  hasBackgroundColor,
  banner,
  onClose,
  ...rest
}: Props & {
  hasBackgroundColor?: boolean;
  tabsContent?: ReactNode;
  banner?: ReactNode;
}) => {
  return (
    <ReactModal
      isOpen
      {...rest}
      onRequestClose={onClose}
      style={{
        ...ModalBaseCss,
        content: {
          ...ModalBaseCss.content,
          display: 'flex',
          overflow: 'hidden',
          flexDirection: 'column',
          inset: '0',
          maxWidth: '100%',
          height: '100vh',
          padding:
            '4px calc(4px + env(safe-area-inset-left)) 0 calc(4px + env(safe-area-inset-left))',
        },
      }}
      contentLabel={title}
      bodyOpenClassName="ReactModal__Body--open"
    >
      {banner && banner}

      {onClose && (
        <ActivitySheetCloseButton $hasBanner={!!banner}>
          <SecondaryButtonIcon
            type="button"
            aria-label={`Close ${title}`}
            data-selector="close-modal"
            $borderRadius={40}
            onClick={onClose}
          >
            <IconClose width={16} height={16} />
          </SecondaryButtonIcon>
        </ActivitySheetCloseButton>
      )}
      <ActivitySheetContent
        data-selector="activity-sheet-content"
        $hasBanner={!!banner}
      >
        {tabsContent}
        <ActivitySheetScrollable
          data-selector="activity-sheet-container"
          id={ACTIVITY_SHEET_CONTAINER}
          $backgroundColor={hasBackgroundColor ? grey2 : grey1}
        >
          {children}
        </ActivitySheetScrollable>
      </ActivitySheetContent>
    </ReactModal>
  );
};

export default ActivitySheet;
